import {
    GET_CUSTOMER_LISTING_FAIL,
    GET_CUSTOMER_LISTING_SUCCESS,
    RESET_CUSTOMER_ACTION_STATE,
    RESET_CUSTOMER_STATE,
    CREATE_CUSTOMER_SUCCESS,
    CREATE_CUSTOMER_FAIL,
    UPDATE_CUSTOMER_SUCCESS,
    UPDATE_CUSTOMER_FAIL,
    GET_CUSTOMER_DETAILS_SUCCESS,
    GET_CUSTOMER_DETAILS_FAIL,
    GET_CUSTOMER_HISTORY_LISTING_SUCCESS,
    GET_CUSTOMER_HISTORY_LISTING_FAIL,
    DELETE_CUSTOMER_SUCCESS,
    DELETE_CUSTOMER_FAIL,
    CUSTOMER_ACTIVATION_SUCCESS,
    CUSTOMER_ACTIVATION_FAIL,
    EXPORT_CUSTOMER_LISTING_SUCCESS,
    EXPORT_CUSTOMER_LISTING_FAIL,
    SWITCH_CUSTOMER_DOCTOR_SUCCESS,
    SWITCH_CUSTOMER_DOCTOR_FAIL,
    GET_CUSTOMER_ORDERS_LISTING_SUCCESS,
    GET_CUSTOMER_ORDERS_LISTING_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    customerListing: [],
    customerDetails: [],
    createCustomer: [],
    updateCustomer: [],
    deleteCustomer: [],
    customerActivation: [],
    exportCustomerListing: [],
    switchCustomerDoctor: [],
    customerHistoryListing: [],
    customerOrdersListing: [],
    error: [],
}

const Customer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMER_LISTING_SUCCESS:
            return {
                ...state,
                customerListing: action.payload
            }
        case GET_CUSTOMER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case CREATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                createCustomer: action.payload,
            };
        case CREATE_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                updateCustomer: action.payload,
            };
        case UPDATE_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_CUSTOMER_DETAILS_SUCCESS:
            return {
                ...state,
                customerDetails: action.payload,
            };
        case GET_CUSTOMER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_CUSTOMER_HISTORY_LISTING_SUCCESS:
            return {
                ...state,
                customerHistoryListing: action.payload,
            };
        case GET_CUSTOMER_HISTORY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_CUSTOMER_ORDERS_LISTING_SUCCESS:
            return {
                ...state,
                customerOrdersListing: action.payload,
            };
        case GET_CUSTOMER_ORDERS_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                deleteCustomer: action.payload,
            };
        case DELETE_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case CUSTOMER_ACTIVATION_SUCCESS:
            return {
                ...state,
                customerActivation: action.payload,
            };
        case CUSTOMER_ACTIVATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case EXPORT_CUSTOMER_LISTING_SUCCESS:
            return {
                ...state,
                exportCustomerListing: action.payload,
            };
        case EXPORT_CUSTOMER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case SWITCH_CUSTOMER_DOCTOR_SUCCESS:
            return {
                ...state,
                switchCustomerDoctor: action.payload,
            };
        case SWITCH_CUSTOMER_DOCTOR_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case RESET_CUSTOMER_ACTION_STATE:
            return {
                ...state,
                createCustomer: [],
                updateCustomer: [],
                deleteCustomer: [],
                customerActivation: [],
                exportCustomerListing: [],
                switchCustomerDoctor: [],
                customerHistoryListing: [],
                customerOrdersListing: [],
                error: [],
            }
        case RESET_CUSTOMER_STATE:
            return {
                ...state,
                customerListing: [],
                customerDetails: [],
                createCustomer: [],
                updateCustomer: [],
                deleteCustomer: [],
                customerActivation: [],
                exportCustomerListing: [],
                switchCustomerDoctor: [],
                customerHistoryListing: [],
                customerOrdersListing: [],
                error: [],
            }
        default:
            return state
    }
}

export default Customer
